import React from 'react';
import { cn } from '@/lib/utils';
import { useLanguage } from '@/context/LanguageContext';

const GraphLegend = ({ className }) => {
  const { language } = useLanguage();
  
  const t = {
    legend: language === 'de' ? 'Legende' : 'Legend',
    nodeSize: language === 'de' ? 'Knotengröße' : 'Node Size',
    balance: language === 'de' ? 'Guthaben' : 'Balance',
    edgeWidth: language === 'de' ? 'Kantenbreite' : 'Edge Width',
    txAmount: language === 'de' ? 'Tx-Betrag' : 'Tx Amount',
    riskLevel: language === 'de' ? 'Risikostufe' : 'Risk Level',
    low: language === 'de' ? 'Niedrig' : 'Low',
    medium: language === 'de' ? 'Mittel' : 'Medium',
    high: language === 'de' ? 'Hoch' : 'High',
    flowDirection: language === 'de' ? 'Flussrichtung' : 'Flow Direction',
    inflow: language === 'de' ? 'Eingang' : 'Inflow',
    outflow: language === 'de' ? 'Ausgang' : 'Outflow',
  };

  return (
    <div className={cn(
      "bg-card/95 backdrop-blur border border-border rounded-lg p-3 text-xs space-y-3",
      className
    )}>
      <h4 className="font-medium text-sm">{t.legend}</h4>
      
      {/* Risk Levels */}
      <div>
        <p className="text-muted-foreground mb-1.5">{t.riskLevel}</p>
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-1.5">
            <div className="w-3 h-3 rounded-full bg-success"></div>
            <span>{t.low}</span>
          </div>
          <div className="flex items-center gap-1.5">
            <div className="w-3 h-3 rounded-full bg-warning"></div>
            <span>{t.medium}</span>
          </div>
          <div className="flex items-center gap-1.5">
            <div className="w-3 h-3 rounded-full bg-destructive"></div>
            <span>{t.high}</span>
          </div>
        </div>
      </div>
      
      {/* Flow Direction */}
      <div>
        <p className="text-muted-foreground mb-1.5">{t.flowDirection}</p>
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-1.5">
            <div className="w-6 h-0.5 bg-success"></div>
            <span>{t.inflow}</span>
          </div>
          <div className="flex items-center gap-1.5">
            <div className="w-6 h-0.5 bg-destructive"></div>
            <span>{t.outflow}</span>
          </div>
        </div>
      </div>
      
      {/* Node Size */}
      <div>
        <p className="text-muted-foreground mb-1.5">{t.nodeSize} = {t.balance}</p>
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 rounded-full bg-muted-foreground"></div>
          <div className="w-3 h-3 rounded-full bg-muted-foreground"></div>
          <div className="w-4 h-4 rounded-full bg-muted-foreground"></div>
          <div className="w-5 h-5 rounded-full bg-muted-foreground"></div>
        </div>
      </div>
      
      {/* Edge Width */}
      <div>
        <p className="text-muted-foreground mb-1.5">{t.edgeWidth} = {t.txAmount}</p>
        <div className="flex items-center gap-2">
          <div className="w-8 h-px bg-muted-foreground"></div>
          <div className="w-8 h-0.5 bg-muted-foreground"></div>
          <div className="w-8 h-1 bg-muted-foreground"></div>
        </div>
      </div>
    </div>
  );
};

export default GraphLegend;
